module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- <h1>Reports</h1>\nThese reports are emailed to people on a set frequency.\n<br>\n<br clear=all> -->\n';
}
return __p;
};
